import { WeSellService } from './WeSellService';
import { MsnAdsService } from './MsnService';
import { MashableAdsService } from './MashableAdsService';
import { ElPaisAdsService } from './ElPaisService';
import { AsAdsService } from './AsAdsService';

declare var THEY_SELL: undefined
  | 'games.msn.com'
  | 'juegos.elpais.com'
  | 'juegos.as.com'
  | 'games.mashable.com';

export const AdsService = 
  THEY_SELL === 'games.msn.com' ? MsnAdsService :
  THEY_SELL === 'games.mashable.com' ? MashableAdsService :
  THEY_SELL === 'juegos.elpais.com' ? ElPaisAdsService :
  THEY_SELL === 'juegos.as.com' ? AsAdsService :
  WeSellService;
